import { ClockStarFourPointsIcon } from './ClockStarFourPointsIcon';

/**
 * author: Jeff Anders
 * id AA756E06-67A0-4182-8A32-CF4968219B68
 * name clock-star-four-points
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/clock-star-four-points.svg
 * tags
 * - Date / Time 
 */
export const ClockAutoIcon = ClockStarFourPointsIcon;
export default ClockAutoIcon